import { api, API_URL, tokenStore } from '@/lib/api';

export const MAX_FILE_SIZE = 20 * 1024 * 1024;
export const ACCEPT_IMAGES = 'image/jpeg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp';
export const ACCEPT_ALL = `${ACCEPT_IMAGES},.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt,.zip`;

export const fmtSize = (n) => {
  if (!n && n !== 0) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

/** URL usable in <img src> / <a href>. Private files get the access token as query param. */
export const fileUrl = (att, { download = false } = {}) => {
  if (!att?.id) return '';
  const name = encodeURIComponent(att.original_filename || att.name || 'file');
  const params = [];
  if (!att.is_public) params.push(`auth=${tokenStore.access}`);
  if (download) params.push('download=true');
  return `${API_URL}/files/${att.id}/${name}${params.length ? `?${params.join('&')}` : ''}`;
};

/** Chunked upload. Resolves with the attachment record. onProgress(0..100). */
export const uploadFile = async (companyId, file, { kind = 'document', refId = null } = {}, onProgress) => {
  if (file.size > MAX_FILE_SIZE) throw new Error('Ukuran file melebihi 20 MB / File exceeds 20 MB');
  const { data: init } = await api.post(`/companies/${companyId}/files/uploads`, { filename: file.name, content_type: file.type || '', size: file.size, kind, ref_id: refId });
  const { upload_id: uploadId, chunk_size: chunkSize } = init;
  let offset = 0;
  let index = 0;
  while (offset < file.size) {
    const chunk = file.slice(offset, offset + chunkSize);
    await api.put(`/companies/${companyId}/files/uploads/${uploadId}/chunks/${index}`, chunk, { headers: { 'Content-Type': 'application/octet-stream' } });
    offset += chunkSize;
    index += 1;
    onProgress?.(Math.min(95, Math.round((Math.min(offset, file.size) / file.size) * 95)));
  }
  const { data } = await api.post(`/companies/${companyId}/files/uploads/${uploadId}/complete`);
  onProgress?.(100);
  return data;
};
